import script from "./InputImage.vue?vue&type=script&setup=true&lang=js"
export * from "./InputImage.vue?vue&type=script&setup=true&lang=js"

import "./InputImage.vue?vue&type=style&index=0&id=c51b4cec&lang=scss"

const __exports__ = script;

export default __exports__